import {useEffect, useRef, useState} from "react";
import {InfoBlock} from "../../../../components/infoBlock";
import {getStatistics} from "../../../../api/dashboard";
import "./style.css";

export const Dashboard = () => {
  const [data, setData] = useState({});
  const [status, setStatus] = useState("loading");
  const pending = useRef(false);
  const queryStatistics = async () => {
    if (pending.current) return;
    pending.current = true;
    setStatus("loading");
    try {
      const response = await getStatistics();
      if (!response || response.error || !response.data?.statistics) throw Error("unavailable");
      setData(response.data.statistics);
      setStatus("ready");
    } catch {
      setStatus("error");
    } finally {
      pending.current = false;
    }
  };
  useEffect(() => {queryStatistics();}, []);
  const infoBlocks = [
    ["Propietarios", "ownersCount"],
    ["Negocios", "businessesCount"],
    ["Clientes globales", "customersCount"],
    ["Pedidos globales", "ordersCount"],
  ];
  return <>
    <div className="topContainer"><div><span className="sa-caption">VISTA GENERAL</span><h1>Resumen de la plataforma</h1><p className="sa-lead">Las cifras de tus negocios, en un mismo lugar.</p></div></div>
    {status === "loading" && <p role="status">Cargando estadísticas…</p>}
    {status === "error" && <div role="alert">No se pudieron cargar las estadísticas. <button type="button" onClick={queryStatistics}>Reintentar estadísticas</button></div>}
    <div className="infoBlocksContainer">{infoBlocks.map(([title, key]) =>
      <InfoBlock key={key} title={title} value={status === "ready" ? (data[key] ?? "—") : "—"} graph={false}/>
    )}</div>
    <div className="adminPanel"><div className="adminPanelContent">
      <h2>Tu plataforma de un vistazo</h2><p>Estos totales reflejan los datos acumulados de la plataforma.</p><p className="sa-muted">Los pedidos y clientes globales incluyen todos los negocios. No representan la actividad de un periodo concreto.</p>
    </div></div>
  </>;
};
